export const PAGE_PERMISSION_CONFIGS = [
  {
    code: 'page.ship_binding',
    tabKey: 'voyage-binding',
    titleKey: 'nav.page.shipBinding',
    defaultTitle: '航次绑定',
    path: '/home/voyage-binding',
    icon: 'cluster-o',
    sort: 1
  },
  {
    code: 'page.pass_record',
    tabKey: 'passage-record',
    titleKey: 'nav.page.passRecord',
    defaultTitle: '通行记录',
    path: '/home/passage-record',
    icon: 'records',
    sort: 2
  },
  {
    code: 'page.fence_alarm',
    tabKey: 'fence-alarm',
    titleKey: 'nav.page.fenceAlarm',
    defaultTitle: '报警信息',
    path: '/home/fence-alarm',
    icon: 'warning-o',
    sort: 3
  },
  {
    code: 'page.statistics',
    tabKey: 'data-statistics',
    titleKey: 'nav.page.statistics',
    defaultTitle: '数据统计',
    path: '/home/data-statistics',
    icon: 'bar-chart-o',
    sort: 4
  },
  {
    code: 'page.access_records',
    tabKey: 'access-records',
    titleKey: 'nav.page.accessRecords',
    defaultTitle: '登记记录',
    path: '/home/access-records',
    icon: 'orders-o',
    sort: 5
  },
  {
    code: 'page.device_manage',
    tabKey: 'device-management',
    titleKey: 'nav.page.deviceManagement',
    defaultTitle: '设备管理',
    path: '/home/device-management',
    icon: 'desktop-o',
    sort: 6
  },
  {
    code: 'page.officer_manage',
    tabKey: 'permanent-personnel',
    titleKey: 'nav.page.permanentPersonnel',
    defaultTitle: '常备人员',
    path: '/home/permanent-personnel',
    icon: 'friends-o',
    sort: 8
  },
  {
    code: 'page.domestic_crew_manage',
    tabKey: 'domestic-crew',
    titleKey: 'nav.page.domesticCrew',
    defaultTitle: '内贸船员',
    path: '/home/domestic-crew',
    icon: 'contact',
    sort: 9
  },
  {
    code: 'page.vehicle_departure',
    tabKey: 'vehicle-departure',
    titleKey: 'nav.page.vehicleDeparture',
    defaultTitle: '车辆离场',
    path: '/home/vehicle-departure',
    icon: 'logistics',
    sort: 10
  },
  {
    code: 'page.access_registration',
    tabKey: 'access-registration',
    titleKey: 'nav.page.accessRegistration',
    defaultTitle: '出入登记',
    path: '/home/access-registration',
    icon: 'description',
    sort: 11,
    menuVisible: true
  },
  {
    code: 'page.live_test',
    tabKey: 'live-test',
    titleKey: 'nav.page.liveTest',
    defaultTitle: '直播测试',
    path: '/home/live-test',
    icon: 'play-circle-o',
    sort: 12
  },
  {
    code: 'page.user_manage',
    tabKey: 'user-management',
    titleKey: 'nav.page.userManagement',
    defaultTitle: '用户管理',
    path: '/home/user-management',
    icon: 'manager-o',
    sort: 7
  },
  {
    code: 'page.permission_manage',
    tabKey: 'permission-management',
    titleKey: 'nav.page.permissionManagement',
    defaultTitle: '权限管理',
    path: '/home/permission-management',
    icon: 'setting-o',
    sort: 13
  }
];

const PUBLIC_PAGE_CONFIGS = [
  {
    tabKey: 'vehicle-departure',
    titleKey: 'nav.page.vehicleDeparture',
    defaultTitle: '车辆离场',
    path: '/home/vehicle-departure'
  },
  {
    tabKey: 'access-registration',
    titleKey: 'nav.page.accessRegistration',
    defaultTitle: '出入登记',
    path: '/home/access-registration'
  },
  {
    tabKey: 'access-registration-person-in',
    titleKey: 'nav.page.accessRegistrationPersonIn',
    defaultTitle: '人员入场登记',
    path: '/home/access-registration/person-in'
  },
  {
    tabKey: 'access-registration-person-out',
    titleKey: 'nav.page.accessRegistrationPersonOut',
    defaultTitle: '人员离场登记',
    path: '/home/access-registration/person-out'
  },
  {
    tabKey: 'access-registration-vehicle-in',
    titleKey: 'nav.page.accessRegistrationVehicleIn',
    defaultTitle: '车辆入场登记',
    path: '/home/access-registration/vehicle-in'
  },
  {
    tabKey: 'access-registration-vehicle-out',
    titleKey: 'nav.page.accessRegistrationVehicleOut',
    defaultTitle: '车辆离场登记',
    path: '/home/access-registration/vehicle-out'
  },
  {
    tabKey: 'access-registration-crew-luggage-in',
    titleKey: 'nav.page.accessRegistrationCrewLuggageIn',
    defaultTitle: '携带行李入闸登记',
    path: '/home/access-registration/crew-luggage-in'
  },
  {
    tabKey: 'access-registration-crew-luggage-out',
    titleKey: 'nav.page.accessRegistrationCrewLuggageOut',
    defaultTitle: '携带行李出闸登记',
    path: '/home/access-registration/crew-luggage-out'
  },
  {
    tabKey: 'access-registration-crew-no-luggage-in',
    titleKey: 'nav.page.accessRegistrationCrewNoLuggageIn',
    defaultTitle: '无行李入闸登记',
    path: '/home/access-registration/crew-no-luggage-in'
  },
  {
    tabKey: 'access-registration-crew-no-luggage-out',
    titleKey: 'nav.page.accessRegistrationCrewNoLuggageOut',
    defaultTitle: '无行李出闸登记',
    path: '/home/access-registration/crew-no-luggage-out'
  }
];

const SUB_ROUTE_MAP = [
  {
    prefix: '/home/camera-management',
    permissionCode: 'page.device_manage',
    tabKey: 'device-management'
  },
  {
    prefix: '/home/video-preview',
    permissionCode: 'page.device_manage',
    tabKey: 'device-management'
  },
  {
    prefix: '/home/user-edit',
    permissionCode: 'page.user_manage',
    tabKey: 'user-management'
  }
];

export function getVisibleTabs(permissionCodes = []) {
  const codeSet = new Set(permissionCodes || []);
  return PAGE_PERMISSION_CONFIGS
    .filter(item => codeSet.has(item.code) && item.menuVisible !== false)
    .sort((a, b) => a.sort - b.sort);
}

export function getDefaultAuthorizedTab(permissionCodes = []) {
  return getVisibleTabs(permissionCodes)[0] || null;
}

export function getPublicPaths() {
  return PUBLIC_PAGE_CONFIGS.map(item => item.path);
}

export function getDefaultAuthorizedPath(permissionCodes = []) {
  const tab = getDefaultAuthorizedTab(permissionCodes);
  return tab ? tab.path : '/home/no-permission';
}

export function getPathByPermissionCode(permissionCode) {
  const page = PAGE_PERMISSION_CONFIGS.find(item => item.code === permissionCode);
  return page ? page.path : '';
}

export function getRequiredPermissionByPath(path) {
  if (!path || path === '/home' || path === '/home/' || path === '/home/no-permission') {
    return null;
  }

  const publicPage = PUBLIC_PAGE_CONFIGS.find(item => item.path === path);
  if (publicPage) {
    return null;
  }

  const exact = PAGE_PERMISSION_CONFIGS.find(item => item.path === path);
  if (exact) {
    return exact.code;
  }

  const subRoute = SUB_ROUTE_MAP.find(item => path.startsWith(item.prefix));
  return subRoute ? subRoute.permissionCode : null;
}

export function getTabKeyByPath(path) {
  const publicPage = PUBLIC_PAGE_CONFIGS.find(item => item.path === path);
  if (publicPage) {
    return publicPage.tabKey;
  }

  const exact = PAGE_PERMISSION_CONFIGS.find(item => item.path === path);
  if (exact) {
    return exact.tabKey;
  }

  const subRoute = SUB_ROUTE_MAP.find(item => path.startsWith(item.prefix));
  return subRoute ? subRoute.tabKey : '';
}

export function getPageTitleByPath(path) {
  const publicPage = PUBLIC_PAGE_CONFIGS.find(item => item.path === path);
  if (publicPage) {
    return publicPage.defaultTitle;
  }

  const exact = PAGE_PERMISSION_CONFIGS.find(item => item.path === path);
  if (exact) {
    return exact.defaultTitle;
  }

  const subRoute = SUB_ROUTE_MAP.find(item => path.startsWith(item.prefix));
  if (!subRoute) {
    return '';
  }

  const parentPage = PAGE_PERMISSION_CONFIGS.find(item => item.tabKey === subRoute.tabKey);
  return parentPage ? parentPage.defaultTitle : '';
}

export function getPageTitleConfigByPath(path) {
  const publicPage = PUBLIC_PAGE_CONFIGS.find(item => item.path === path);
  if (publicPage) {
    return {
      titleKey: publicPage.titleKey,
      defaultTitle: publicPage.defaultTitle
    };
  }

  const exact = PAGE_PERMISSION_CONFIGS.find(item => item.path === path);
  if (exact) {
    return {
      titleKey: exact.titleKey,
      defaultTitle: exact.defaultTitle
    };
  }

  const subRoute = SUB_ROUTE_MAP.find(item => path.startsWith(item.prefix));
  if (!subRoute) {
    return null;
  }

  const parentPage = PAGE_PERMISSION_CONFIGS.find(item => item.tabKey === subRoute.tabKey);
  return parentPage
    ? {
        titleKey: parentPage.titleKey,
        defaultTitle: parentPage.defaultTitle
      }
    : null;
}
